import Component from '@glimmer/component';
import type { BufferedChangeset } from 'ember-changeset/types';
import FileUpload from '../file-upload.gts';
import ValidatedField from '../validated-field.gts';

interface Signature {
  Args: {
    changeset: BufferedChangeset;
    propertyName: string;
    acceptedTypes?: string[];
  };
}

export default class ChangesetFileUpload extends Component<Signature> {
  /**
   * Callback function which is given
   * to the File upload component.
   * Will be called within the component
   * when upload is successful.
   */
  onSelected = (file: File): void => {
    const files = this.args.changeset.get(this.args.propertyName);
    const isFirstSelectedFile = Boolean(!files);

    if (isFirstSelectedFile) {
      this.args.changeset.set(this.args.propertyName, [file]);
    } else {
      files.push(file);
      this.args.changeset.set(this.args.propertyName, files);
    }
  };

  /**
   * Callback function which is given
   * to the File upload component.
   * Will be called within the component
   * when a file is deleted.
   */
  destroyFile = (index: number): void => {
    const files = this.args.changeset.get(this.args.propertyName);
    files?.splice(index, 1);
    this.args.changeset.set(this.args.propertyName, files);
  };

  /**
   * File upload accepted types.
   * When upload button is clicked and
   * file explorer opens, only those
   * types would be uploadable.
   */
  get acceptedTypes(): Array<string> {
    return (
      this.args.acceptedTypes || [
        'application/pdf',
        'image/jpeg',
        'image/jpg',
        'image/png',
        'application/rtf'
      ]
    );
  }

  <template>
    <ValidatedField
      @propertyName={{@propertyName}}
      @changeset={{@changeset}}
      @errorClass='error-validated-input-display'
    >
      <FileUpload
        {{! @glint-expect-error }}
        @onSelected={{this.onSelected}}
        @onDestroy={{this.destroyFile}}
        @acceptedTypes={{this.acceptedTypes}}
        @isMandatory={{false}}
      />
    </ValidatedField>
  </template>
}
